// @ts-nocheck
import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTypedSelector } from '../hooks/useTypedSelector';
import { blue } from '@mui/material/colors';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from '../styles/ButtonTextStyle';

interface RenameEntityModalProps {
  isOpen: boolean;
  onClose: () => void;
  headerTitle: string;
  currentEntityName: string;
  onRename: (newName: string) => void;
}

const RenameEntityDialog: React.FC<RenameEntityModalProps> = ({
  isOpen,
  onClose,
  headerTitle,
  currentEntityName,
  onRename,
}) => {
  const [input, setInput] = useState(currentEntityName);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const { board } = useTypedSelector((state) => state.project);
  const [isOpenMessage, setIsOpenMessage] = useState(false);
  const [duplicateMessage, setDuplicateMessage] = useState('');

  useEffect(() => {
    setIsButtonDisabled(input.length === 0);
  }, [input]);

  function handleRename(input: string) {
    const isDuplicatePhaseName = board.lanes.some((l) => l.title === input);
    if (isDuplicatePhaseName) {
      setDuplicateMessage(`The phase with this name "'${input}' already exists`);
      setIsOpenMessage(true);
      return;
    }
    const trimmedInput = input.trim();
    if (trimmedInput != currentEntityName) {
      onRename(trimmedInput);
    }

    onClose();
  }

  const handleCloseMessage = () => {
    setIsOpenMessage(false);
  };

  return (
    <>
      <Dialog
        open={isOpen}
        onClose={onClose}
        maxWidth="md"
        sx={{
          '& .MuiDialog-container': {
            '& .MuiPaper-root': {
              maxWidth: '492px',
            },
          },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: 600,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            pr: 1,
          }}
        >
          {headerTitle}
          <IconButton onClick={onClose} size="small" aria-label="close">
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <input
            autoFocus
            id="name"
            value={input}
            placeholder="Enter a new name for the phase..."
            onChange={(e) => setInput(e.target.value)}
            className="dialog-textinput mb-3"
          />
        </DialogContent>
        <ThemeProvider theme={theme}>
          <DialogActions>
            <Button
              variant="contained"
              color="info"
              onClick={() => handleRename(input)}
              disabled={isButtonDisabled}
            >
              Rename
            </Button>
          </DialogActions>
        </ThemeProvider>
      </Dialog>
      <Dialog open={isOpenMessage} onClose={handleCloseMessage}>
        <DialogTitle>{duplicateMessage}</DialogTitle>
      </Dialog>
    </>
  );
};

export default RenameEntityDialog;
